<template>
    <div id="waveBatchUpdateRef">
        <a-modal v-model="visible" :title="$t('pubGicSet.BatchUpdate')" :maskClosable="false"  >
            <template slot="footer">
              <a-button size="small" type="primary" @click="saveCheck">{{$t('userlang.Save')}}</a-button>
            </template>
            <a-form :form="form" >
                <a-form-item :label="ref1Label"  v-bind="formItemLayout">
                    <batch-updat-edit-form :key="datekey" :fieldType="ref1FieldType" :span="14" :propsValue="ref1" :checkFlag="checkboxRef1" @ref1FieldValueChange="ref1FieldValueChangeCallBack"></batch-updat-edit-form>
                </a-form-item>
                <a-form-item :label="ref2Label"  v-bind="formItemLayout">
                    <batch-updat-edit-form :key="datekey" :fieldType="ref2FieldType" :span="14" :propsValue="ref2" :checkFlag="checkboxRef2" @ref2FieldValueChange="ref2FieldValueChangeCallBack"></batch-updat-edit-form>
                </a-form-item>
                <a-form-item :label="ref3Label"  v-bind="formItemLayout" >
                    <batch-updat-edit-form :key="datekey" :fieldType="ref3FieldType" :span="14" :propsValue="ref3" :checkFlag="checkboxRef3" @ref3FieldValueChange="ref3FieldValueChangeCallBack"></batch-updat-edit-form>
                </a-form-item>
                <a-form-item :label="ref4Label"  v-bind="formItemLayout" >
                    <batch-updat-edit-form :key="datekey" :fieldType="ref4FieldType" :span="14" :propsValue="ref4" :checkFlag="checkboxRef4" @ref4FieldValueChange="ref4FieldValueChangeCallBack"></batch-updat-edit-form>
                </a-form-item>
                <a-form-item :label="ref5Label"  v-bind="formItemLayout" >
                    <batch-updat-edit-form :key="datekey" :fieldType="ref5FieldType" :span="14" :propsValue="ref5" :checkFlag="checkboxRef5" @ref5FieldValueChange="ref5FieldValueChangeCallBack"></batch-updat-edit-form>
                </a-form-item>
                <a-form-item :label="dueDateLabel"  v-bind="formItemLayout" >
                  <batch-updat-edit-form :key="datekey" :fieldType="dueDateFieldType" :span="14" :propsValue="dueDate" :checkFlag="checkboxDueDate" @ref5FieldValueChange="dueDateFieldValueChangeCallBack"></batch-updat-edit-form>
                </a-form-item>
                <a-form-item :label="etdDateLabel"  v-bind="formItemLayout" >
                  <batch-updat-edit-form :key="datekey" :fieldType="etdDateFieldType" :span="14" :propsValue="etdDate" :checkFlag="checkboxEtdDate" @ref5FieldValueChange="etdDateFieldValueChangeCallBack"></batch-updat-edit-form>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import batchUpdatEditForm from './batchUpdatEditForm.vue'

    export default{
        components: {batchUpdatEditForm},
        data(){
            return{
                datekey:Date.now(),
                labelName: '',
                ref1Label:'Ref 01',
                ref2Label:'Ref 02',
                ref3Label:'Ref 03',
                ref4Label:'Ref 04',
                ref5Label:'Ref 05',
                dueDateLabel:'Due Data',
                etdDateLabel:'ETD Data',
                ref1:'',
                ref2:'',
                ref3:'',
                ref4:'',
                ref5:'',
                dueDate:null,
                etdDate:null,
                ref1FieldType:'String',
                ref2FieldType:'String',
                ref3FieldType:'String',
                ref4FieldType:'String',
                ref5FieldType:'String',
                dueDateFieldType:'Datetime',
                etdDateFieldType:'Datetime',
                checkboxRef1:false,
                checkboxRef2:false,
                checkboxRef3:false,
                checkboxRef4:false,
                checkboxRef5:false,
                checkboxDueDate:false,
                checkboxEtdDate:false,
                ajaxtype: '',
                uids: [],
                visible: false,
                form:this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                parentGmcUid:'',
            }
        },
        watch:{

        },
        methods:{
            show(name,type,uids,parentGmcUid){
                this.uids = uids
                this.labelName = name
                this.visible = true
                this.ajaxtype = type
                this.parentGmcUid=parentGmcUid
                this.resetData();

                ajax.get(api.GETWAVEHEADERBATCHUPDATEINFO,{gmcuid: this.parentGmcUid}).then(res=>{
                    let data = res.data;
                    this.ref1Label = data.ref1Label;
                    this.ref2Label = data.ref2Label;
                    this.ref3Label = data.ref3Label;
                    this.ref4Label = data.ref4Label;
                    this.ref5Label = data.ref5Label;
                    this.dueDateLabel = data.dueDateLabel;
                    this.etdDateLabel = data.etdDateLabel;
                    this.ref1FieldType = data.ref1FieldType;
                    this.ref2FieldType = data.ref2FieldType;
                    this.ref3FieldType = data.ref3FieldType;
                    this.ref4FieldType = data.ref4FieldType;
                    this.ref5FieldType = data.ref5FieldType;
                    this.dueDateFieldType = data.dueDateFieldType;
                    this.etdDateFieldType = data.etdDateFieldType;

                })
            },
            ref1FieldValueChangeCallBack(val,flag) {
              this.ref1 = val;
              this.checkboxRef1 = flag;
            },
            ref2FieldValueChangeCallBack(val,flag) {
                this.ref2 = val;
                this.checkboxRef2 = flag;
            },
            ref3FieldValueChangeCallBack(val,flag) {
                this.ref3 = val;
                this.checkboxRef3 = flag;
            },
            ref4FieldValueChangeCallBack(val,flag) {
                this.ref4 = val;
                this.checkboxRef4 = flag;
            },
            ref5FieldValueChangeCallBack(val,flag) {
                this.ref5 = val;
                this.checkboxRef5 = flag;
            },
            dueDateFieldValueChangeCallBack(val,flag) {
              this.dueDate = val;
              this.checkboxDueDate = flag;
            },
            etdDateFieldValueChangeCallBack(val,flag) {
              this.etdDate = val;
              this.checkboxEtdDate = flag;
            },
            saveCheck(){
              if(this.checkboxDueDate){
                let params = {
                  "uids": this.uids,
                  "dueDate": this.dueDate,
                  "checkboxDueDate": this.checkboxDueDate,
                }
                ajax.post(api.WAVEHEADERBATCHUPDATEREFCHECKDUEDATE,params).then(res=>{
                  if(res.code == 200){
                    if(res.data!=null){
                      let that = this;
                      this.$customConfirm({
                        title: that.$t('DueDateUpdateConfirm')+"\n"+res.data,
                        okText: that.$t('publicLang.Confirm'),
                        cancelText: that.$t('publicLang.Cancel'),
                        content: "",
                        onOk() {
                          that.save();
                        }
                      });
                    }else{
                      this.save();
                    }
                  }else{
                    this.$customMessage.warning(res.msg)
                  }
                })
              }else{
                this.save();
              }
            },
            save(){
                  // 至少选一个，否则报错
              if(!(this.checkboxRef1 || this.checkboxRef2 || this.checkboxRef3 || this.checkboxRef4 || this.checkboxRef5 || this.checkboxDueDate || this.checkboxEtdDate) ) {
                       this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                       return;
                   }
                   let params = {}
                   let ajaxTypeName = ''
                   if(this.ajaxtype == 'waveBatchUpdate'){
                       ajaxTypeName = api.WAVEHEADERBATCHUPDATEREF
                       params = {
                           "uids": this.uids,
                           "ref1": this.ref1,
                           "ref2": this.ref2,
                           "ref3": this.ref3,
                           "ref4":this.ref4,
                           "ref5": this.ref5,
                           "dueDate": this.dueDate,
                           "etdDate": this.etdDate,
                           "checkboxRef1": this.checkboxRef1,
                           "checkboxRef2": this.checkboxRef2,
                           "checkboxRef3": this.checkboxRef3,
                           "checkboxRef4": this.checkboxRef4,
                           "checkboxRef5": this.checkboxRef5,
                           "checkboxDueDate": this.checkboxDueDate,
                           "checkboxEtdDate": this.checkboxEtdDate,
                       }
                   }
                   ajax.post(ajaxTypeName,params).then(res=>{
                       if(res.code == 200){
                           this.$message.success(res.msg)
                           this.visible = false
                          this.$emit('refreshWave')
                       }else{
                           this.$customMessage.warning(res.msg)
                       }
                   })


            },
            resetData() {
                this.datekey=Date.now(),
                this.ref1 = '';
                this.ref2 = '';
                this.ref3 = '';
                this.ref4 = '';
                this.ref5 = '';
                this.dueDate = null;
                this.etdDate = null;
                this.checkboxRef1=false;
                this.checkboxRef2=false;
                this.checkboxRef3=false;
                this.checkboxRef4=false;
                this.checkboxRef5=false;
                this.checkboxDueDate=false;
                this.checkboxEtdDate=false;
            },


        }
    }
</script>